




















































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, PropSync, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Alert,
  AlertMessage,
  defaultBirthdayJapaneseSymbol,
  defaultSystemCode,
  defaultSystemCodeAddress,
  defaultSystemCodeArea,
  ErrorMessage,
  SystemCode,
  SystemCodeAddress,
  SystemCodeArea,
  userApi
} from '@/api'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import {
  alertStore,
  dataStore,
  modalErrorStore,
  systemCodeStore,
  systemParameterStore
} from '@/utils/store-accessor'
import {
  UserPhoneTable,
  UserPhoneTableItem
} from '@/components/organisms/UserPhoneTable'
import {
  UserMailAddressTable,
  UserMailAddressTableItem
} from '@/components/organisms/UserMailAddressTable'
import dayjs from 'dayjs'
import { InputCodeAddress } from '@/components/molecules/InputCodeAddress'
import { InputCodeArea } from '@/components/molecules/InputCodeArea'
import { AlertFactory } from '@/factory'
import { InputCode } from '@/components/molecules/InputCode'
import { AlertCodeAL400002, MaskPattern, UserDetailStateInfo } from '@/types'

export interface UserContentBasicItem {
  id: string
  registeredDate: {
    input: string
    errorMessage: string
  }
  branchCode: {
    input: string
    display: string
    errorMessage: string
  }
  myBranchCode: {
    input: string
    display: string
    errorMessage: string
  }
  reserveReceivePlaceCode: {
    input: string
    display: string
    errorMessage: string
  }
  ppid: string
  felicaId: string
  birthdayJapaneseSymbol: {
    input: SystemCode
    errorMessage: string
  }
  birthday: {
    input: string
    errorMessage: string
  }
  gender: {
    input: SystemCode
    errorMessage: string
  }
  groupType: {
    input: string
    display: string
    errorMessage: string
  }
  reserveNotice: {
    input: string
    display: string
    errorMessage: string
  }
  myPageEnabled: {
    input: boolean
    errorMessage: string
  }
  reserveEnabled: {
    input: boolean
    errorMessage: string
  }
  password: {
    input: string
    errorMessage: string
  }
  registeredPassword: string
  passwordRegisteredDate: string
  disability: {
    input: boolean
    errorMessage: string
  }
  readingSupportEnabled: {
    input: boolean
    errorMessage: string
  }
  numberOfGroupMembers: {
    input: string
    errorMessage: string
  }
  numberOfGroupChildren: {
    input: string
    errorMessage: string
  }
  phones: UserPhoneTableItem[]
  addressCode: {
    input: SystemCodeAddress
    errorMessage: string
  }
  zipCode: {
    input: string
    errorMessage: string
  }
  areaCode: {
    input: SystemCodeArea
    errorMessage: string
  }
  address: {
    input: string
    errorMessage: string
  }
  mailAddresses: UserMailAddressTableItem[]
}

export const defaultUserContentBasicItem = (): UserContentBasicItem => ({
  id: '',
  registeredDate: {
    input: '',
    errorMessage: ''
  },
  branchCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  myBranchCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  reserveReceivePlaceCode: {
    input: '',
    display: '',
    errorMessage: ''
  },
  ppid: '',
  felicaId: '',
  birthdayJapaneseSymbol: {
    input: defaultBirthdayJapaneseSymbol(),
    errorMessage: ''
  },
  birthday: {
    input: '',
    errorMessage: ''
  },
  gender: {
    input: defaultSystemCode(),
    errorMessage: ''
  },
  groupType: {
    input: '',
    display: '',
    errorMessage: ''
  },
  reserveNotice: {
    input: '',
    display: '',
    errorMessage: ''
  },
  myPageEnabled: {
    input: true,
    errorMessage: ''
  },
  reserveEnabled: {
    input: true,
    errorMessage: ''
  },
  password: {
    input: '',
    errorMessage: ''
  },
  registeredPassword: '',
  passwordRegisteredDate: '',
  disability: {
    input: false,
    errorMessage: ''
  },
  readingSupportEnabled: {
    input: false,
    errorMessage: ''
  },
  numberOfGroupMembers: {
    input: '0',
    errorMessage: ''
  },
  numberOfGroupChildren: {
    input: '0',
    errorMessage: ''
  },
  phones: [],
  addressCode: {
    input: defaultSystemCodeAddress(),
    errorMessage: ''
  },
  zipCode: {
    input: '',
    errorMessage: ''
  },
  areaCode: {
    input: defaultSystemCodeArea(),
    errorMessage: ''
  },
  address: {
    input: '',
    errorMessage: ''
  },
  mailAddresses: []
})

@Component({
  components: {
    InputCode,
    InputCodeAddress,
    InputCodeArea,
    InputDatePicker,
    UserPhoneTable,
    UserMailAddressTable
  }
})
export default class UserContentBasic extends ComponentVue {
  @PropSync('item', {
    type: Object,
    required: true
  })
  inputItem!: UserContentBasicItem

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  displayPasswordRequiredLabel!: boolean

  get cssCustomProperty(): any {
    return {
      '--height': this.height + 'px'
    }
  }

  get numberOnlyMask(): string {
    return MaskPattern.NumberOnly
  }

  get birthdayIsRequired() {
    return this.state.isCreateOrUpdate()
      ? systemParameterStore.isRequireUserBirthday
      : false
  }

  get genderIsRequired() {
    return this.state.isCreateOrUpdate()
      ? systemParameterStore.isRequireUserGender
      : false
  }

  get addressCodeIsRequired() {
    return this.state.isCreateOrUpdate()
      ? systemParameterStore.isRequireUserAddressCode
      : false
  }

  get zipcodeIsRequired() {
    return this.state.isCreateOrUpdate()
      ? systemParameterStore.isRequireUserZipcode
      : false
  }

  get areaCodeIsRequired() {
    return this.state.isCreateOrUpdate()
      ? systemParameterStore.isRequireUserAreaCode
      : false
  }

  get addressIsRequired() {
    return this.state.isCreateOrUpdate()
      ? systemParameterStore.isRequireUserAddress
      : false
  }

  get japaneseCalendarTypeSystemCodes(): SystemCode[] {
    return systemCodeStore.getJapaneseCalendarTypeWithAD
  }

  get genderSystemCodes(): SystemCode[] {
    return systemCodeStore.getGender
  }

  get age(): string {
    if (this.inputItem.birthday.input) {
      const age = dayjs().diff(dayjs(this.inputItem.birthday.input), 'year')
      if (age < 0) {
        return ''
      }
      return `${age}歳`
    }

    return ''
  }

  get opacPassword(): string {
    return this.opacPasswordIsHidden
      ? '＊'.repeat(this.inputItem.password.input.length)
      : this.inputItem.password.input
  }

  get opacPasswordIsHidden(): boolean {
    return systemParameterStore.userOpacPassword.option3 !== '1'
  }

  get showOpacPasswordResetButton(): boolean {
    return !(
      systemParameterStore.userOpacPassword.option1 === '0' ||
      systemParameterStore.userOpacPassword.option1 === '5' ||
      this.state.isCreate()
    )
  }

  get enabledMyNumberCard(): boolean {
    return dataStore.enabledMyNumberCard
  }

  existsMobileLibraryPlaceCodes(branchCode: string): boolean {
    return systemParameterStore.mobileLibraryPlaceCodes(branchCode).length > 0
  }

  exclusionForwardingPlaceCodes(branchCode: string): string[] {
    return systemCodeStore.getPlaceCode
      .filter(placeCode =>
        systemParameterStore
          .mobileLibraryPlaceCodes(branchCode)
          .every(mobilePlaceCode => mobilePlaceCode.code !== placeCode.code)
      )
      .map(systemCode => systemCode.code)
  }

  get enabledFelica(): boolean {
    return dataStore.enabledFelica
  }

  get displayMyBranch(): boolean {
    return dataStore.displayUserPageMyBranch
  }

  get displayReserveReceivePlace(): boolean {
    return dataStore.displayUserPageReserveReceivePlace
  }

  get displayReserveContactMethod(): boolean {
    return dataStore.displayUserPageReserveContactMethod
  }

  get displayOpacSetting(): boolean {
    return dataStore.displayUserPageOpacSetting
  }

  get displayOther(): boolean {
    return dataStore.displayUserPageOther
  }

  get displayAddress(): boolean {
    return dataStore.displayUserPageAddress
  }

  get displayMailAddress(): boolean {
    return dataStore.displayUserPageMailAddress
  }

  @Watch('inputItem.myBranchCode.input')
  inputMyBranchCode(newVal: string, oldVal: string): void {
    this.resetErrorMessage(this.inputItem.myBranchCode)
    if (newVal !== oldVal) {
      this.inputItem.reserveReceivePlaceCode.input = ''
      this.inputItem.reserveReceivePlaceCode.errorMessage = ''
    }
  }

  setBirthday(value: string) {
    this.resetErrorMessage(this.inputItem.birthday)
    if (value.length > 6) {
      this.inputItem.birthdayJapaneseSymbol.input = defaultBirthdayJapaneseSymbol()
    }
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  inputAddressCode(systemCodeAddress: SystemCodeAddress): void {
    this.inputItem.addressCode.input = systemCodeAddress
    this.inputItem.addressCode.errorMessage = ''
    if (systemCodeAddress.id > 0 && systemCodeAddress.code.length === 6) {
      this.inputItem.zipCode.input = systemCodeAddress.zipCode
      this.inputItem.areaCode.input = systemCodeAddress.areaCode
      this.inputItem.address.input = systemCodeAddress.name

      this.inputItem.zipCode.errorMessage = ''
      this.inputItem.areaCode.errorMessage = ''
      this.inputItem.address.errorMessage = ''
    }
  }

  inputZipCode(systemCodeAddress: SystemCodeAddress): void {
    this.inputItem.addressCode.input = {
      ...this.inputItem.addressCode.input,
      ...{ zipCode: systemCodeAddress.zipCode }
    }
    this.inputItem.zipCode.input = systemCodeAddress.zipCode
    this.inputItem.addressCode.errorMessage = ''
    this.inputItem.zipCode.errorMessage = ''
  }

  inputModalZipCode(systemCodeAddress: SystemCodeAddress): void {
    this.inputItem.addressCode.input = systemCodeAddress
    this.inputItem.zipCode.input = systemCodeAddress.zipCode
    this.inputItem.areaCode.input = systemCodeAddress.areaCode
    this.inputItem.address.input = systemCodeAddress.name
    this.inputItem.addressCode.errorMessage = ''
    this.inputItem.zipCode.errorMessage = ''
    this.inputItem.areaCode.errorMessage = ''
    this.inputItem.address.errorMessage = ''
  }

  onClickResetOpacPassword() {
    const alert: Alert = AlertFactory.create(AlertCodeAL400002)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: this.resetOpacPassword
    })
  }

  async resetOpacPassword() {
    try {
      const response: string = await userApi.resetOpacPassword(
        this.inputItem.id
      )

      // パスワードを更新している為登録日を設定
      // 今日の日付を設定することが決まっているので画面側で用意
      if (this.inputItem.registeredPassword === '') {
        this.inputItem.passwordRegisteredDate = dayjs().format('YYYYMMDD')
      }

      this.inputItem.password.input = response
      this.inputItem.registeredPassword = response
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }
}
